<template>
  <div class="address-select__wrapper">
    <el-radio-group class="setting-type" v-model="typeLocal">
      <el-radio-button
        v-for="item in addressTypeList"
        :key="item.id"
        :label="item.id"
        >{{ item.label }}</el-radio-button
      >
    </el-radio-group>
    <!--区域选择-->
    <vr-select
      v-show="typeLocal === typeKey.area"
      v-model="addressLocal"
      :data="areaList"
      :is-title="true"
      :props="areaListListMap"
      class="address-select"
      @change="handleSelectChange"
    />
    <!--行政区选择-->
    <e6-city
      v-show="typeLocal === typeKey.city"
      ref="citySelect"
      width="255px"
      :format="['省', '市', '区县']"
      placeholder="请选择"
      :bin="Number(addressLocal)"
      @selected="handleCitySelect"
      class="address-select"
    />
  </div>
</template>

<script>
export default {
  inject: ["selectListCollection"],

  props: {
    type: String,
    // 显示类型的键值映射
    typeKey: {
      type: Object,
      default: () => ({ area: "1", city: "3" })
    },
    address: [String, Number]
  },

  computed: {
    typeLocal: {
      get() {
        // 不是区域，则统一当省处理，兼容省，省市，省市区
        const { type, typeKey } = this;
        return type === typeKey.area ? typeKey.area : typeKey.city;
      },

      set(val) {
        this.addressLocal = "";
        this.clearCity();
        this.$emit("update:type", val);
        this.$emit("change", false);
      }
    },

    addressLocal: {
      get() {
        return Number(this.address) || 0;
      },

      set(val) {
        this.$emit("update:address", val);
      }
    },

    addressTypeList() {
      const { typeKey } = this;

      return [
        { label: "区域", id: typeKey.area },
        { label: "省市区", id: typeKey.city }
      ];
    },

    // 下拉数据
    areaList: vm => vm.selectListCollection.areaList,
    areaListListMap: vm => vm.selectListCollection.areaListListMap
  },

  methods: {
    handleCitySelect({ bin, name }) {
      this.addressLocal = bin;
      this.$emit("change", true, { id: bin, label: name });
      this.$emit("selectCity");
    },

    handleSelectChange(...args) {
      this.$emit("change", ...args);
    },

    clearCity() {
      this.$refs.citySelect.clearCity();
    }
  }
};
</script>

<style lang="scss" scoped>
.address-select__wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  /deep/ .el-radio-group {
    flex-shrink: 0;
    flex-grow: 0;

    .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0;
    }
  }

  /deep/ .address-select {
    flex: 1;

    .el-input__inner {
      border-radius: 0 4px 4px 0;
      border-left: 0;
    }

    .city-input {
      width: 100% !important;
      border-radius: 0 4px 4px 0;
      border-left: 0;
    }
  }
}
</style>
